import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Button,
    Card, Divider,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PostbackGuide from "./PostbackGuide";
import {affiliateApi} from "../../api/affiliateApi";
import PostbackSimulator from "./PostbackSimulator";


const Postback = () => {
    const [settings, setSettings] = useState({
        postbackRegUrl: '',
        postbackQftdUrl: ''
    });
    const [alert, setAlert] = useState(null);

    useEffect(() => {
        affiliateApi.getSettings().then(resp => setSettings(resp));
    }, []);

    const updateSettings = () => {
        affiliateApi.updateSettings({ affiliate: settings })
            .then(() => setAlert(<Alert severity="success">Update postback url is successful</Alert>))
            .catch(r => setAlert(<Alert severity="error">{r.response.data.message}</Alert>));
    }

    const UpdateButton = () => {
        return <Button variant='outlined' onClick={updateSettings}>Update</Button>
    }

    return <>
        { alert }
        <Stack direction='column' spacing={4}>
            <PostbackCard>
                <Typography> Registration Postback Url </Typography>
                <Stack sx={{ mt: 2 }} direction='row' spacing={2}>
                    <TextField
                        fullWidth
                        value={settings.postbackRegUrl}
                        onChange={(e) => setSettings((prevSettings) => ({
                            ...prevSettings,
                            postbackRegUrl: e.target.value
                        }))}
                    />
                    <UpdateButton/>
                </Stack>
            </PostbackCard>

            <PostbackCard>
                <Typography> FTD Postback URL </Typography>
                <Stack sx={{ mt: 2 }} direction='row' spacing={2}>
                    <TextField
                        fullWidth
                        value={settings.postbackQftdUrl}
                        onChange={(e) => setSettings((prevSettings) => ({
                            ...prevSettings,
                            postbackQftdUrl: e.target.value
                        }))}
                    />
                    <UpdateButton/>
                </Stack>
            </PostbackCard>

            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography component="span">How to Set Up Postback</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <PostbackSimulator/>
                    <Divider sx={{ mt: 2, mb: 2 }}/>
                    <PostbackGuide/>
                </AccordionDetails>
            </Accordion>
        </Stack>

        {/* api for testing urls */}

    </>
}

const PostbackCard = ({ children }) => {
    return <Card sx={{ p: 4 }} >
        { children }
    </Card>
}

export default Postback;
